<template>
  <div class="plan my-0 py-1">
    <b-field grouped >
      <b-icon
          v-if="!isNew"
          class="drag-handle pt-4 pr-1"
          icon="drag">
      </b-icon>
      <b-icon
          v-if="isNew"
          class="pt-4 pr-1"
          icon="plus">
      </b-icon>
      <figure v-if="!isNew" class="m-0 mx-2 p-0 ">
        <img class="thumbnail" :src="thumbnailSrc">
      </figure>
      <b-autocomplete class="is-flex-grow-1 mr-1" custom-class="has-text-weight-bold"
            v-model="plan.title"
            field="title"
            :disabled="!isNew"
            :data="suggestions"
            :loading="isLoading"
            placeholder="Select a plan..."
            open-on-focus
            keep-first
            @typing="getAsyncData"
            @select="option => selected(option)">
            <template slot-scope="props">
              <div class="media p-2">
                        <div class="media-left">
                            <img width="48" :src="`${optionThumbnailSrc(props.option)}`">
                        </div>
                        <div class="media-content">
                            <h1 class="is-size-5 has-text-weight-bold pb-0 mb-0">{{ props.option.title }}</h1>
                            <p class="is-size-8 mt-1">
                              <span :class="[
                                          'tag',
                                          {'is-danger is-light': props.option.status == 'draft'},
                                          {'is-warning': props.option.status == 'test'},
                                          {'is-info': props.option.status == 'fix'},
                                          {'is-success': props.option.status == 'live'}
                                        ]">
                                    <b>{{ props.option.status }}</b>
                                </span>
                              Date: <b>{{ formatDate(props.option.date) }}</b>,
                            </p>
                        </div>
                    </div>
            </template>
         </b-autocomplete>
         <b-field v-if="!isNew" class="mr-1 ">
            <b-tag 
              size="is-large"
              :type="tagType(plan.status, 'is-light')" >{{formatDate(plan.date)}}</b-tag>
        </b-field>
        <b-field v-if="!isNew" class="mr-1">
            <b-tag 
              size="is-large"
              :type="tagType(plan.status, '')" >{{ plan.status }}</b-tag>
        </b-field>
      <p class="control">
        <b-button v-if="!isNew" class="mr-2" icon-right="arrow-right" @click="viewPlan">View plan</b-button>
        <b-button v-if="isNew" :disabled="!isValidPlan" type="is-primary" icon-right="plus" @click="add" />
        <b-button v-else icon-right="delete" @click="remove" />
      </p>
    </b-field>
  </div>
</template>

<script>
//import db from "@/firebase/db"
import debounce from 'lodash/debounce'
import search from '../search'
import DateFormatter from "@/formatters/DateFormatter"
import db from "@/firebase/db"

export default {
  name: 'EditMealPlan',
  props: {
    planIn: Object,
    isNew: Boolean
  },
  data() {
    return {
      plan: null,
      query: '',
      suggestions: [],
      isLoading: false
    }
  },
  created() {
    this.plan = this.planIn ?? { id: null, title: "", images: null };
    
  },
  mounted() {
    this.suggestions = this.getAsyncData("");
  },
  computed: {
    isValidPlan() {
      return this.plan.id != null
    },
    filteredSuggestions() {
      return this.suggestions.filter(option => {
        return option.title.toLowerCase().indexOf(this.plan.title.toLowerCase()) >= 0
      });
    },
    thumbnailSrc() {
      if (this.plan.images != null && this.plan.images[0] != null) {
        return this.plan.images[0].src;
      }
      return require("../assets/listing-placeholder.png");
    }
  },
  methods: {
      getAsyncData: debounce(function (query) {
        // String update
        if (this.query !== query) {
            this.query = query;
            this.suggestions = [];
        }
        // String cleared
        if (!query.length) {
            this.suggestions = []
            return
        }
        
        this.isLoading = true;

        let searchParameters = {
          'q'         : query,
          'preset'    : 'admin_meal_plan_search',
          'sort_by': '_text_match:desc',
          'per_page': '100'
        };

        // NB!!! 
        // This search is hardcoded to the live Typesense Cluster! 
        // TODO: install a local version for developing locally! 
        let that = this;
        search.collections('meal_plans')
          .documents()
          .search(searchParameters)
          .then(function (searchResults) {
            that.suggestions = searchResults.hits.map((hit) => hit.document );
            console.log(that.suggestions);
          })
          .finally(() => {
            that.isLoading = false;
          })
      }, 500),
    selected(option) {
      if (option == null) {
        return;
      }

      // Fetch the full thing to save some stuff not in the Search Indices
      db.collection('meal_plans')
        .doc(option.id)
        .get()
        .then(snapshot => {
          if (snapshot.exists) {

            let fullPlan = snapshot.data();
            this.plan.id = option.id;
            this.plan.title = fullPlan.title;
            this.plan.status = fullPlan.status;
            this.plan.images = fullPlan.images;
            this.plan.date = fullPlan.date;
            this.plan.date_string = fullPlan.date_string;
            this.plan.backgroundColour = fullPlan.backgroundColour;
            this.plan.highlightColour = fullPlan.highlightColour;
            this.plan.recipes_count = Object.keys(fullPlan.recipes).length;
            this.plan.recipes = fullPlan.recipes;
            
            setTimeout(() => this.add(), 50); // timeout here is weird but allows us time to clear the empty input field
            
          }else {
            console.log(`Warning: Plan does not exist - Skipping!`);
            this.$buefy.notification.open({type: 'is-danger', message: `Warning: Plan does not exist - Skipping!`})
          }

        })
        .catch((error) => {
          this.$buefy.notification.open({type: 'is-danger', message: `Error fetching plan: ${error}`})
        });
      
    },
    add() {
      this.$emit('add-plan', this.plan);
      this.plan = { id: null, title: "", images: null };
    },
    remove() {
      this.$emit('remove-plan', this.plan);
    },
    viewPlan() {
      this.$router.push({ name: 'MealPlanView', params: { id: this.plan.id } })
    },
    optionThumbnailSrc(option) {
      if (option.images == null) { return null;}
      let image = option.images[0];
      if (image != null) {
        return image.src;
      }
      return null;
    },
    formatDate(dateTime) {
      return DateFormatter.displayDate(dateTime);
    },
    tagType(status, isLight){
      switch (status){
        case "draft":
          return `is-danger ${isLight}`;
        case "test":
          return `is-warning ${isLight}`;
        case "fix":
          return `is-info ${isLight}`;
        case "live":
          return `is-success ${isLight}`;
      }
    }
  }
}
</script>

<style>

.tag-style{
  font-size: 1rem;
}

.thumbnail{

  width: 40px;
  height: 40px;
  object-fit: cover;
}
</style>
